module.exports = __webpack_public_path__ + "static/media/buttonsounds06.05a38ada.wav";